import { customFetch } from "@/client/custom-fetch";

import { TCampaignContactsTemplate, TCampaignUploadSummary } from "./campaign-upload.types";

export const uploadCampaignContacts = async (
  campaignId: string,
  file: File
): Promise<TCampaignUploadSummary> => {
  const formData = new FormData();
  formData.append("file", file);

  return customFetch<TCampaignUploadSummary>(
    `/campaigns/${campaignId}/contacts/upload`,
    {
      method: "POST",
      body: formData,
    }
  );
};

export const getCampaignContactsTemplate =
  async (): Promise<TCampaignContactsTemplate> => {
    return customFetch<TCampaignContactsTemplate>("/campaigns/contacts/template");
  };
